module.exports = __webpack_public_path__ + "static/img/ndvi1.b1e1cb78.jpg";